/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourcePostureResponse {
    getFixupPrototypeFunction() { return ResourcePostureResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourcePostureResponse>): ResourcePostureResponse {
        let obj = Object.assign(new ResourcePostureResponse(), model);
        ResourcePostureResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourcePostureResponse>): ResourcePostureResponse {
        if (!model) return null;
        return ResourcePostureResponse.newInstance(<ResourcePostureResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourcePostureResponse) {
        if (!obj) return;

        models.ResourcePostureResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourcePostureResponse): boolean {
        Object.setPrototypeOf(obj, ResourcePostureResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.tenants) {
            for (let val of this.tenants) {
                models.PostureTenantModel.fixupPrototype(val);
            }
        }
        if (this.cloud_data) {
            for (let val of this.cloud_data) {
                models.PostureCloudModel.fixupPrototype(val);
            }
        }
        if (this.cloud_account_data) {
            for (let val of this.cloud_account_data) {
                models.PostureCloudDataModel.fixupPrototype(val);
            }
        }
    }

    /**
     * count details
     */
    total_count: number;

    /**
     * List of tenant data
     */
    tenants: Array<models.PostureTenantModel>;

    /**
     * List of cloud data
     */
    cloud_data: Array<models.PostureCloudModel>;

    /**
     * List of cloud account data
     */
    cloud_account_data: Array<models.PostureCloudDataModel>;

}
